import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss']
})
export class WarningDialogComponent {
  confirmMessage: string;
  menssageSubtitle: string;
  confirmMessageButton: string;
  modalError: boolean;
  cancelButton = true;

  constructor(public warningDialog: MatDialogRef<WarningDialogComponent>) {}
}
